var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrackingTemplate',{attrs:{"order":_vm.order}})
}
var staticRenderFns = []

export { render, staticRenderFns }